module.exports = __webpack_public_path__ + "media/images/restore-4bd0c6db.svg";